__turbopack_context__.v({
  "helios-program-card": "wdIuSq_helios-program-card",
  "helios-program-card--list": "wdIuSq_helios-program-card--list",
  "helios-program-card__badge": "wdIuSq_helios-program-card__badge",
  "helios-program-card__body": "wdIuSq_helios-program-card__body",
  "helios-program-card__cta": "wdIuSq_helios-program-card__cta",
  "helios-program-card__cta-arrow": "wdIuSq_helios-program-card__cta-arrow",
  "helios-program-card__description": "wdIuSq_helios-program-card__description",
  "helios-program-card__icon": "wdIuSq_helios-program-card__icon",
  "helios-program-card__image": "wdIuSq_helios-program-card__image",
  "helios-program-card__link": "wdIuSq_helios-program-card__link",
  "helios-program-card__list-body": "wdIuSq_helios-program-card__list-body",
  "helios-program-card__list-row": "wdIuSq_helios-program-card__list-row",
  "helios-program-card__meta": "wdIuSq_helios-program-card__meta",
  "helios-program-card__meta-item": "wdIuSq_helios-program-card__meta-item",
  "helios-program-card__title": "wdIuSq_helios-program-card__title",
  "helios-program-card__type": "wdIuSq_helios-program-card__type",
});
